





























































































import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { IndicadBolsasTipoPacFiltrosDTO } from '@/interfaces/crm-institution';
import { listInstitutionChartPrescrTpPatient } from '@/services/crm-institution';
import { ADULT, getPatientType, NEWBORN, PEDIATRIC } from '@/settings/consts/patient';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    GChart
  }
})
export default class InstitutionPrescrCharts extends BaseComponent {
  @Prop()
  id: number;

  items = [];
  res: any = {};
  loading = false;

  monthOptions = [
    { id: 6, label: '6 meses' },
    { id: 12, label: '12 meses' },
    { id: 24, label: '24 meses' }
  ];

  months = 6;
  multi = null;
  type = 't';

  mounted() {}

  public headers: any = [
    { text: 'Mês', value: 'mesAno', sortable: false },
    { text: 'Neonato', value: 'neonatal', sortable: false, align: 'right' },
    { text: 'Pediátrico', value: 'pediatrico', sortable: false, align: 'right' },
    { text: 'Adulto', value: 'adulto', sortable: false, align: 'right' },
    { text: 'Total', value: 'total', sortable: false, align: 'right' }
  ];

  chartData: any[] = [];

  chartOptions = {
    backgroundColor: 'transparent',
    height: 400,
    chartArea: { left: '50', top: '70', right: '50', bottom: '130' },
    legend: { position: 'bottom' },
    //isStacked: true,
    colors: [getPatientType(NEWBORN).iconColor, getPatientType(PEDIATRIC).iconColor, getPatientType(ADULT).iconColor],
    fontSize: 12,
    hAxis: {
      slantedText: true,
      slantedTextAngle: 45
    }
  };

  @Watch('id', { immediate: true })
  onIdChange(id) {
    if (!id) {
      return;
    }
    this.load();
  }

  tableKey = 1;

  load() {
    let f = new IndicadBolsasTipoPacFiltrosDTO();
    f.idInstituicao = this.id;
    f.meses = this.months;
    f.bolsaMulti = this.multi;
    this.loading = true;
    listInstitutionChartPrescrTpPatient(f).subscribe(
      (res) => {
        this.res = res;
        this.items = res.dados;
        this.loading = false;
        this.loadChart();
        this.tableKey++;
      },
      (error) => {
        this.showToastApiError(error);
        this.loading = false;
      }
    );
  }

  loadChart() {
    this.chartData = [];
    if (!this.items.length) {
      return;
    }
    this.chartData.push([
      'Mês',
      'Neonato',
      { role: 'annotation' },
      'Pediatrico',
      { role: 'annotation' },
      'Adulto',
      { role: 'annotation' }
    ]);
    this.items.forEach((i) => {
      this.chartData.push([i.mesAnoDesc, i.neonato, null, i.pediatrico, null, i.adulto, null]);
    });
    this.chartData.push([
      "★ " + this.res.media.descricao,
      this.res.media.neonato,
      this.res.media.neonato,
      this.res.media.pediatrico,
      this.res.media.pediatrico,
      this.res.media.adulto,
      this.res.media.adulto
    ]);
    this.chartData.push([
      this.res.mesAtual.mesAnoDesc,
      this.res.mesAtual.neonato,
      null,
      this.res.mesAtual.pediatrico,
      null,
      this.res.mesAtual.adulto,
      null
    ]);
    this.chartData.push([
      "★ " + this.res.projecao.descricao,
      this.res.projecao.neonato,
      this.res.projecao.neonato,
      this.res.projecao.pediatrico,
      this.res.projecao.pediatrico,
      this.res.projecao.adulto,
      this.res.projecao.adulto
    ]);
  }
}
